import { memo } from 'react'
import { Menu, Popover } from '@headlessui/react'
import { GrLock } from 'react-icons/gr'
import { classNames } from '@app/utils/classes'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import {
  btnStyles,
  disabledBtnStyle,
  getMoreMenuStyle,
} from '../../cells/menu/styles'
import { MoreOptionsBaseMock } from './more-base-mock'
import type { MoreOptionsProps } from '@app/types/website-more-options'

const MoreOptionsComponentMock = (
  props: MoreOptionsProps & { translation?: string }
) => {
  const { t } = useTranslation(props.translation || 'dashboard')
  const {
    url,
    removePress,
    crawlWebsite,
    pageHeaders,
    index,
    handleMainClick,
    // verified,
  } = props

  const account = {
    activeSubscription: true,
  }

  return (
    <MoreOptionsBaseMock {...props} index={index}>
      <Menu.Item>
        {({ active }) => (
          <button
            onClick={crawlWebsite}
            className={getMoreMenuStyle(active, true)}
            type='button'
            disabled={!crawlWebsite}
          >
            {t('sync')}
          </button>
        )}
      </Menu.Item>

      <Popover>
        <Popover.Button
          type='button'
          className={'w-full'}
          disabled={!account.activeSubscription}
        >
          {account.activeSubscription ? (
            <Menu.Item as={'div'}>
              {({ active }) => (
                <div
                  className={getMoreMenuStyle(
                    active,
                    account.activeSubscription
                  )}
                >
                  {t('edit')}
                  {!account.activeSubscription ? (
                    <GrLock className='grIcon' />
                  ) : null}
                </div>
              )}
            </Menu.Item>
          ) : (
            <div className={classNames(btnStyles, disabledBtnStyle)}>
              {t('edit')}
              {!account.activeSubscription ? (
                <GrLock className='grIcon' />
              ) : null}
            </div>
          )}
        </Popover.Button>
      </Popover>
      <Menu.Item>
        {({ active }) => (
          <button
            className={getMoreMenuStyle(active, account.activeSubscription)}
            type='button'
            disabled={!account.activeSubscription}
            onClick={handleMainClick(
              pageHeaders,
              'Headers',
              false,
              url as string
            )}
          >
            {t('update')} {t('headers')}
            {!account.activeSubscription ? <GrLock className='grIcon' /> : null}
          </button>
        )}
      </Menu.Item>
      <Menu.Item>
        {({ active }) => (
          <button
            className={getMoreMenuStyle(active, account.activeSubscription)}
            type='button'
            disabled={!account.activeSubscription}
          >
            {t('r-audit')}
            {!account.activeSubscription ? <GrLock className='grIcon' /> : null}
          </button>
        )}
      </Menu.Item>
      {typeof removePress === 'function' ? (
        <div className='border-t dark:border-gray-800'>
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={removePress}
                type='button'
                className={classNames(
                  btnStyles,
                  `rounded-b hover:text-red-700`,
                  active
                    ? 'bg-gray-200 text-red-500 dark:text-white dark:bg-red-900'
                    : 'text-red-700 dark:text-red-500'
                )}
              >
                {t('delete')}
              </button>
            )}
          </Menu.Item>
        </div>
      ) : null}
    </MoreOptionsBaseMock>
  )
}

export const MoreOptionsMock = memo(MoreOptionsComponentMock)
